import { DialogContent } from '@mui/material'

export default DialogContent
